import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { IDepartment, IUserDepartment } from './user-department.model';
import { IUserInfo, AuthService } from '../shared/core/index';
import { ILookup } from '../shared/lookup';
import { HttpService } from '../shared/core/http.service';

@Injectable()
export class UserDepartmentService {

    private _userInfo: IUserInfo;    
    private _userDepartmentAPIUrl = new URL('userdepartment', process.env.API_URL).toString();

    titles: ILookup[];

    constructor(private _http: Http, private _httpService: HttpService, private authService: AuthService) {
        this.authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }

    getDepartments(): Observable<IUserDepartment> {
        const url = new URL(this._userDepartmentAPIUrl).toString();

            return this._httpService.httpGet(url)
                .map((response: Response) => {
                    return this.mapDepartments(response);
                })
                .do(data => data)
                .catch(this.handleError);
    }

    mapDepartments(response: Response): IUserDepartment {
        
        let body = response.json();
        var ret = this.toDepartment(body);
        return ret;
    }

    toDepartment(r: any): IUserDepartment {
        
        let departments = <IUserDepartment>
            ({
                email: r.Email
            });  

            departments.userDepartments = new Array<IDepartment>();    
        if (r.UserDepartments) {
            r.UserDepartments.forEach(element => {
                var userDepartment: IDepartment = new IDepartment();
                userDepartment.department = element.Department;
                departments.userDepartments.push(userDepartment);
            });
        }

        return departments;
    }

    private handleError(error: Response) {
        return Observable.throw(error || 'Server error');
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/user-department/user-department.service.ts